import request from '@/utils/request'

/**
 * 获取课程学生学习数据汇总
 * @param {Number} courseId 课程ID
 */
export function getCourseSummary(courseId) {
  return request({
    url: `/amc/data-collection/course/${courseId}/summary`,
    method: 'get'
  })
}

/**
 * 获取学生详细学习数据
 * @param {Number} studentId 学生ID
 * @param {Number} courseId 课程ID
 */
export function getStudentDetail(studentId, courseId) {
  return request({
    url: `/amc/data-collection/student/${studentId}/course/${courseId}`,
    method: 'get'
  })
}

/**
 * 导出课程学习数据
 * @param {Number} courseId 课程ID
 */
export function exportCourseData(courseId) {
  return request({
    url: `/amc/data-collection/course/${courseId}/export`,
    method: 'get'
  })
}
